import * as dfns from "date-fns";

export class DateUtil {
  static toDate(date?: DateType) {
    return dfns.toDate(date);
  }

  static isValid(date?: DateType) {
    return dfns.isValid(date);
  }

  static format(date: DateType, formatStr = "yyyy-MM-dd HH:mm:ss") {
    return dfns.format(new Date(date), formatStr);
  }

  static formatDistanceToNow(
    date: DateType,
    options?: dfns.FormatDistanceOptions
  ) {
    return dfns.formatDistanceToNow(new Date(date), options);
  }

  static isBefore(date1: DateType, date2: DateType): boolean {
    return dfns.isBefore(new Date(date1), new Date(date2));
  }

  static isAfter(date1: DateType, date2: DateType): boolean {
    return dfns.isAfter(new Date(date1), new Date(date2));
  }

  static getSeconds(date: DateType) {
    return dfns.getSeconds(new Date(date));
  }

  static addSeconds(date: DateType, amount: number) {
    return dfns.addSeconds(new Date(date), amount);
  }

  static addMinutes(date: DateType, amount: number) {
    return dfns.addMinutes(new Date(date), amount);
  }

  static addHours(date: DateType, amount: number) {
    return dfns.addHours(new Date(date), amount);
  }

  static addDays(date: DateType, amount: number) {
    return dfns.addDays(new Date(date), amount);
  }

  static subDays(date: DateType, amount: number) {
    return dfns.subDays(new Date(date), amount);
  }

  static differenceInSeconds(data1: DateType, date2: DateType) {
    return dfns.differenceInSeconds(new Date(data1), new Date(date2));
  }

  static differenceInYears(data1: DateType, date2: DateType) {
    return dfns.differenceInYears(new Date(data1), new Date(date2));
  }

  static lastWednesdayOfMonth(date = new Date()) {
    const lastDayOfQuarterDate = dfns.lastDayOfMonth(date);

    // return lastWednesdayOfWeek(lastDayOfQuarterDate);

    return dfns.isWednesday(lastDayOfQuarterDate)
      ? lastDayOfQuarterDate
      : dfns.previousWednesday(lastDayOfQuarterDate);
  }

  static lastWednesdayOfQuarter(date = new Date()) {
    return DateUtil.lastWednesdayOfMonth(dfns.lastDayOfQuarter(date));
  }

  static lastWednesdayOfWeek(date = new Date()) {
    const currentDate = new Date(date);
    const day = dfns.getDay(currentDate);

    return day === 3
      ? currentDate
      : day > 3 || !day
        ? dfns.previousWednesday(currentDate)
        : dfns.nextWednesday(currentDate);
  }
}

export type DateType = Date | string | number;
